module.exports = __webpack_public_path__ + "img/桑山太斗.13e0c0ec.jpg";